import { render, staticRenderFns } from "./PageSettlementRecord.vue?vue&type=template&id=bb4bab9e&scoped=true&"
import script from "./PageSettlementRecord.vue?vue&type=script&lang=js&"
export * from "./PageSettlementRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4bab9e",
  null
  
)

export default component.exports